import React, { useMemo, Dispatch, SetStateAction } from "react";
import { INFO_DATA } from "data/detail";
import { DetailInfo, InfoData, RenderInfoData } from "interfaces/detail";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import Button from "components/common/buttons/buttons";
import { TYPO } from "styles/Typo";

function AssetInfo({
  type,
  setType,
  detailInfo,
  cat,
}: {
  type: string;
  setType: Dispatch<SetStateAction<string>>;
  detailInfo: DetailInfo;
  cat: string;
}) {
  const router = useRouter();

  const infoData: InfoData[] = useMemo(() => {
    if (detailInfo) {
      const { ITEM_CD, ITEM_CD_DL, ITEM_ENG_NM, ...infData }: DetailInfo =
        detailInfo;
      const entries = Object.entries(infData);

      const arr = entries.map(
        ([key, value]: [string, string | number | null]) => ({ key, value })
      );

      return arr;
    }
    return [];
  }, [detailInfo]);

  const { t } = useTranslation("detail");

  const renderData: RenderInfoData[] = useMemo(() => {
    for (let i = 0; i < INFO_DATA.length; i++) {
      for (let j = 0; j < infoData.length; j++) {
        if (INFO_DATA[i].originalData == infoData[j].key) {
          //@ts-ignore
          INFO_DATA[i].value = infoData[j].value;
          break;
        }
      }
    }
    return INFO_DATA;
  }, [infoData]);

  const filteredArray = useMemo(() => {
    return renderData.filter(({ title, value }) => {
      return (
        value &&
        value !== "NA" &&
        !["Category", "Country", "Website", "Sector", "Industry"].includes(
          title
        )
      );
    });
  }, [renderData]);

  return (
    <main id="itemInfo" className="mb-3 w-full bg-white">
      <div className="flex flex-col p-5 space-y-5">
        <div>
          <p className={`${TYPO.TYPO4_B} text-gray80`}>{t("assetInfo")}</p>
        </div>

        <ul className="flex flex-col space-y-3">
          {filteredArray.map((item, index) => {
            if (index % 2 !== 0) return null;

            const currentItem = item;
            const nextItem = filteredArray[index + 1];

            return (
              <li key={currentItem.id} className="flex justify-between">
                <div className="flex flex-col w-1/2">
                  <p className="text-gray-400 text-sm">
                    {router.locale === "ko"
                      ? currentItem.koreanTitle
                      : currentItem.title}
                  </p>
                  <p
                    className={`${
                      currentItem.title === "White Paper"
                        ? "underline text-blue40 cursor-pointer"
                        : ""
                    } font-semibold truncate`}
                    onClick={() => {
                      if (currentItem.title === "White Paper")
                        window.open(currentItem.value as string, "_blank");
                    }}
                  >
                    {currentItem.title === "White Paper"
                      ? router.locale === "ko"
                        ? "조회하기"
                        : "Show More"
                      : currentItem.title === "Category"
                      ? (currentItem.value || "")[0].toUpperCase() +
                        (currentItem.value || "").slice(1)
                      : isNaN(parseFloat(currentItem.value || ""))
                      ? currentItem.value || ""
                      : parseFloat(currentItem.value || "").toLocaleString()}
                  </p>
                </div>
                {nextItem && (
                  <div className="flex flex-col w-1/2">
                    <p className="text-gray-400 text-sm">
                      {router.locale === "ko"
                        ? nextItem.koreanTitle
                        : nextItem.title}
                    </p>
                    <p
                      className={`${
                        nextItem.title === "White Paper"
                          ? "underline text-blue40 cursor-pointer"
                          : ""
                      } font-semibold truncate`}
                      title="value"
                      onClick={() => {
                        if (nextItem.title === "White Paper")
                          window.open(nextItem.value as string, "_blank");
                      }}
                    >
                      {nextItem.title === "White Paper"
                        ? router.locale === "ko"
                          ? "조회하기"
                          : "Show More"
                        : nextItem.title === "Category"
                        ? (nextItem.value || "")[0].toUpperCase() +
                          (nextItem.value || "").slice(1)
                        : isNaN(parseFloat(nextItem.value || ""))
                        ? nextItem.value || ""
                        : parseFloat(nextItem.value || "").toLocaleString()}
                    </p>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
        {/* {cat !== "Crypto" && cat !== "Index" && type !== "assetInfo" && (
          <Button
            clickHandler={() => {
              setType(type === "assetInfo" ? "" : "assetInfo");
            }}
            type={"tertiary"}
            size={"lg"}
            text={t("viewMore")}
            width="w-full"
          />
        )} */}
      </div>
    </main>
  );
}

export default AssetInfo;
